import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconUserAdd = props => (
  <SvgIcon {...props} viewBox="0 0 22 15.85">
    <path d="m14 7.925c2.21 0 4-1.7732 4-3.9625s-1.79-3.9625-4-3.9625-4 1.7732-4 3.9625 1.79 3.9625 4 3.9625zm-9-1.9805v-2.9719h-2v2.9719h-3v1.9813h3v2.9719h2v-2.9719h3v-1.9813h-3zm9 3.9617c-2.67 0-8 1.3274-8 3.9626v1.9812h16v-1.9812c0-2.635-5.33-3.9628-8-3.9628z" />
  </SvgIcon>
);

export default IconUserAdd;



// WEBPACK FOOTER //
// ./src/components/icons/IconUserAdd.js